import * as actionType from "../constants/actionTypes";


const initialState = {
  templates: [],
  loading: false,
  error: null,
  message: "",
};

const listOfTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SAVE_TEMPLATE:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload?.content || "Saved successfully",
        // Note: If you want to auto-add the template name to the list, you can do:
        // templates: [...state.templates, action.payload?.templateName],
      };

    case actionType.FETCH_TEMPLATES:
      return {
        ...state,
        templates: action.payload?.content || [],
        loading: false,
        error: null,
        message: "Fetched successfully",
      };

    case actionType.DELETE_TEMPLATE:
      return {
        ...state,
        templates: state.templates.filter(
          (template) => template !== action.payload?.name
        ),
        loading: false,
        error: null,
        message: action.payload?.message || "Deleted successfully",
      };

    default:
      return state;
  }
};

export default listOfTemplatesReducer;
